export class DataLayerStaticData {
  public static readonly PRODUCT_QUANTITY = 1;
  public static readonly PRODUCT_BRAND = 'Microsoft';
  public static readonly CURRENCY = 'NOK';
  public static readonly PRODUCT_INDEX = 0;
  public static readonly HARDWARE_CATEGORY = 'Hardware';
  public static readonly GAMING_CATEGORY = 'Gaming';
  public static readonly XBOX_CATEGORY = 'Xbox';
}
